import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";

import Box from "@material-ui/core/Box";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import DialogContent from "@material-ui/core/DialogContent";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";

import Select from "@material-ui/core/Select";
import InputAdornment from "@material-ui/core/InputAdornment";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import Slide from "@material-ui/core/Slide";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";

import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import AppleIcon from "@material-ui/icons/Apple";

import FBIcon from "@components/Global/Custom/Icons/FBIcon";
import GoogleIcon from "@components/Global/Custom/Icons/GoogleIcon";
import TextField from "@components/Global/Custom/TextField";
//import TextField from "@material-ui/core/TextField";
import FacebookLogin from "@components/Global/Social/FacebookLogin";
import GoogleLogin from "@components/Global/Social/GoogleLogin";

import ArrowBackOutlinedIcon from "@material-ui/icons/ArrowBackOutlined";
//import Login from "@components/Main/Login/Login.component";

const { LINK_HELP, GOOGLE_CLIENT_ID, BRAND_NAME, FB_APP_ID } = process.env;

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

function ElevationScroll(props) {
	const { children, target, onElevationChange } = props; // `target` is a ref to the scrollable element
	const [elevated, setElevated] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			if (target.current) {
				const isElevated = target.current.scrollTop > 70;
				setElevated(isElevated);
				onElevationChange(isElevated);
			}
		};

		const scrollableElement = target.current;
		scrollableElement.addEventListener("scroll", handleScroll);

		return () => {
			scrollableElement.removeEventListener("scroll", handleScroll);
		};
	}, [target, onElevationChange]);

	// Define custom elevation styles
	const elevationStyle = elevated
		? {
				boxShadow: "0 2px 4px 0 rgba(13,22,25,.058)",
				backgroundColor: "#FFF",
		  }
		: {
				boxShadow: "none",
		  };

	// Apply custom styles to the children component
	return React.cloneElement(children, {
		style: { ...children.props.style, ...elevationStyle },
	});
}

const WebsiteLogin = ({ open, onClose, ...props }) => {
	const classes = useStyles("Website");

	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));

	const dialogContentRef = React.useRef(null);

	const [isElevated, setIsElevated] = useState(false);

	const handleElevationChange = (elevated) => {
		setIsElevated(elevated);
	};

	// steps

	const [currentStep, setCurrentStep] = useState(1);

	const handleNextClick = () => {
		setCurrentStep(currentStep + 1);
	};

	const handlePreviousClick = () => {
		setCurrentStep(currentStep - 1);
	};

	// Close dialog

	const handleCloseClick = () => {
		onClose();
	};

	return (
		<Dialog
			scroll={"paper"}
			fullScreen={fullScreen}
			fullWidth={true}
			maxWidth={"xs"}
			open={open}
			onClose={onClose}
			TransitionComponent={Transition}
			keepMounted
			classes={{
				paper: classes.dialogPaper,
				container: classes.dialogContainer,
			}}
			BackdropProps={{
				style: {
					backgroundColor: "rgba(182, 192, 205, 0.6)",
				},
			}}
		>
			<ElevationScroll
				target={dialogContentRef}
				onElevationChange={handleElevationChange}
				{...props}
			>
				<DialogTitle
					style={{
						minHeight: 64,
						textAlign: "left",
						display: "flex",
						alignItems: "center",
					}}
					disableTypography
				>
					{currentStep === 2 && (
						<Box position={"absolute"} top={8} left={5}>
							<IconButton aria-label="close" onClick={handlePreviousClick}>
								<ArrowBackOutlinedIcon />
							</IconButton>
						</Box>
					)}
					{isElevated && (
						<Box fontSize={20} fontWeight={600} ml={8} mr={8}>
							Log in or sign up
						</Box>
					)}
					<Box position={"absolute"} top={8} right={5}>
						<IconButton aria-label="close" onClick={handleCloseClick}>
							<CloseIcon />
						</IconButton>
					</Box>
				</DialogTitle>
			</ElevationScroll>
			<DialogContent
				//dividers={hasOptions}
				//style={{ borderTop: "unset", paddingTop: 0 }}
				ref={dialogContentRef}
			>
				<Box pb={4}>
					{currentStep === 1 && (
						<>
							{/* <Login /> */}

							<Box
								display={"flex"}
								justifyContent={"space-between"}
								alignItems={"center"}
								mb={2}
							>
								<div>
									<Box fontSize={28} fontWeight={600} mb={2}>
										Log in or sign up
									</Box>
									<Box color={"grey.600"} fontSize={15} mb={4}>
										Log in or sign up to make or manage your bookings
									</Box>
								</div>
							</Box>

							<Grid container spacing={3}>
								{FB_APP_ID && (
									<Grid item xs={12}>
										<FacebookLogin
											//callback={facebookCallbackHandler}
											appId={FB_APP_ID}
											className={classes.buttonSocial}
											fullWidth
											size={"large"}
											variant="contained"
											disableElevation
											startIcon={<FBIcon />}
											button_name="Continue with Facebook"
											//onFailure={onError}
											xfbml={true}
										/>
									</Grid>
								)}
								{GOOGLE_CLIENT_ID && (
									<Grid item xs={12}>
										<GoogleLogin
											//	callback={googleCallbackHandler}
											client_id={GOOGLE_CLIENT_ID}
											className={classes.buttonSocial}
											fullWidth
											size={"large"}
											variant="contained"
											disableElevation
											startIcon={<GoogleIcon />}
											button_name="Continue with Google"
										/>
									</Grid>
								)}
							</Grid>

							<div className={classes.loginSeparator}>OR</div>

							<form //onSubmit={loginOnClickHandler}
							>
								<Grid container spacing={4}>
									<Grid item xs={12}>
										<TextField
											//value={store.email}
											//onChange={emailOnChangeHandler}
											variant="outlined"
											fullWidth
											label="Email address"
											id="username"
											type="email"
											required={false}
										/>
									</Grid>
								</Grid>
							</form>
						</>
					)}

					{currentStep === 2 && (
						<>
							<Box
								display={"flex"}
								justifyContent={"space-between"}
								alignItems={"center"}
								//mb={2}
							>
								<div>
									<Box fontSize={28} fontWeight={600} mb={2}>
										Create account
									</Box>
									<Box color={"grey.600"} fontSize={15} mb={4}>
										Create your new account by completing these details
									</Box>
								</div>
							</Box>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={6}>
									<Box
										component="div"
										mb={1.5}
										mt={3}
										fontWeight={600}
										fontSize={15}
									>
										First name *
									</Box>
									<TextField
										groupId={"join"}
										//value={store.firstName}
										//onChange={(e) => handleChange("_firstName", e.target.value)}
										variant="outlined"
										fullWidth
										autoCorrect="off"
										//label={"First name"}
										id="first_name"
										name="first_name"
										autoComplete="given-name"
										inputProps={{
											autoCorrect: "off",
											spellCheck: "false",
										}}
										aria-label="First name"
										//onValidation={(isValid) =>
										//	handleValidation(isValid, "firstName")
										//}
									/>
								</Grid>

								<Grid item xs={12} sm={6}>
									<Box
										component="div"
										mb={1.5}
										mt={3}
										fontWeight={600}
										fontSize={15}
									>
										Last name *
									</Box>
									<TextField
										groupId={"join"}
										//value={store.lastName}
										//	onChange={(e) => handleChange("_lastName", e.target.value)}
										variant="outlined"
										fullWidth
										autoCorrect="off"
										//label={"Last name"}
										id="last_name"
										name="last_name"
										autoComplete="family-name"
										inputProps={{
											autoCorrect: "off",
											spellCheck: "false",
										}}
										//	aria-label="Last name"
										//	onValidation={(isValid) => handleValidation(isValid, "lastName")}
									/>
								</Grid>

								<Grid item xs={12}>
									<Box
										component="div"
										mb={1.5}
										mt={3}
										fontWeight={600}
										fontSize={15}
									>
										Password *
									</Box>
									<TextField
										groupId={"join"}
										type={"password"}
										//	value={store.password}
										//	onChange={(e) => handleChange("_password", e.target.value)}
										variant={"outlined"}
										//label="Password"
										InputProps={{
											labelWidth: 80,
										}}
										fullWidth
										name="password"
										id="password"
										//	onValidation={(isValid) => handleValidation(isValid, "password")}
									/>
								</Grid>

								<Grid item xs={12}>
									<Box
										component="div"
										mb={1.5}
										mt={3}
										fontWeight={600}
										fontSize={15}
									>
										Mobile number *
									</Box>

									<Box
										display={"flex"}
										alignItems={"center"}
										style={{ gap: 12 }}
									>
										<FormControl variant="outlined" style={{ width: 140 }}>
											<Select
												native
												value={"day"}
												IconComponent={ExpandMoreIcon}
												inputProps={{
													name: "time",
													id: "time",
												}}
											>
												<option value="day">+1</option>
												<option value="week">On the third Tuesday</option>
											</Select>
										</FormControl>

										<TextField
											required={false}
											type="tel"
											fullWidth
											variant="outlined"
											//groupId="admin-client-edit"
											id="phone"
											placeholder={"(555) 555-5555"}
											//label="Phone Number"
											autoComplete="tel"
											//value={store.phone}
											//onChange={(e, phone) => store.updateField("phone", phone)}
										/>
									</Box>
								</Grid>

								<Grid item xs={12}>
									<Box
										display="flex"
										alignItems={"center"}
										justifyContent={"space-between"}
										mt={2}
									>
										<FormControlLabel
											control={
												<Checkbox
													//defaultChecked={true}
													name="checkedB"
													color="primary"
												/>
											}
											label={
												<>
													<Box fontSize={15}>
														I agree to the{" "}
														<Link style={{ fontSize: 15 }}>Privacy Policy</Link>{" "}
														and <Link>Terms of Use</Link>
													</Box>
												</>
											}
										/>
									</Box>

									<Box
										display="flex"
										alignItems={"center"}
										justifyContent={"space-between"}
										mt={3}
									>
										<FormControlLabel
											control={
												<Checkbox
													//defaultChecked={true}
													name="checkedB"
													color="primary"
												/>
											}
											label={
												<>
													<Box fontSize={15}>
														I agree to receive marketing notifications with
														offers and news
													</Box>
												</>
											}
										/>
									</Box>
								</Grid>
							</Grid>
						</>
					)}
				</Box>
			</DialogContent>
			<DialogActions style={{ padding: "12px 24px 24px" }}>
				<Box
					display={"flex"}
					flexDirection={"row"}
					justifyContent={"space-between"}
					width={"100%"}
					m={"0 auto"}
					maxWidth={600}
				>
					<Button
						fullWidth
						onClick={handleNextClick}
						size={"large"}
						variant="contained"
						color="primary"
						disableElevation
						className={classes.buttonCTA}
						//disabled={hasOptions ? !selectedOption : false}
					>
						Next
					</Button>
				</Box>
			</DialogActions>
		</Dialog>
	);
};

WebsiteLogin.propTypes = {};
export default WebsiteLogin;
